import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import CustomModal from "../../widgets/CustomModal";
import CustomBtn from "../../widgets/CustomBtn";
import InfiniteScroll from "../../services/InfiniteScroll";
import {
  addAssembly,
  assemblyList,
  deleteAssembly,
  updateAssembly
} from '../../_slice/assemblyPointSlice'
import AppContext from "../../context/AppContext";
import editImg from "../../../assets/images/edit.png";
import deleteImg from "../../../assets/images/delete.png";

function AssemblyPoint() {
  const [modalShow, setModalShow] = useState({ show: false, id: "" });
  const [deleteModal, setDeleteModal] = useState({
    show: false,
    id: "",
    name: "",
  });
  const [checkedState, setCheckedState] = useState({});
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { setLoader } = useContext(AppContext);
  const locationId = location?.state?.orglocation?.locationId || ''

  // React Hook Form setup
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors,
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      name: '',
      location_id: locationId || ''
    }
  })

  // Redux selector to get Assembly data and status
  const { assemblyData, status: assemblyStatus } = useSelector(
    state => state.assembly
  )

  // Effect to fetch assembly initially or on status change
  useEffect(() => {
    if (assemblyStatus === 'idle' || locationId) {
      // dispatch(assemblyList({ setLoader, locationId }));
      fetchMoreAssembly(0);
    }
  }, [locationId, navigate, dispatch, setLoader]);


  // Function to fetch more location
  const fetchMoreAssembly = (resetPage) => {
    const pageCount = resetPage > 0 ? resetPage : page;
    dispatch(assemblyList({ locationId, pageCount, navigate, setLoader }))
      .then((response) => {
        // console.log('response', response);
        if (response?.payload?.data?.assemblyPoints?.data?.length > 0) {
          setPage(response?.payload?.data?.assemblyPoints?.current_page + 1);
          setHasMore(
            response?.payload?.data?.assemblyPoints?.current_page <
            response?.payload?.data?.assemblyPoints?.last_page
          );
        } else {
          setHasMore(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching more assemblyPoints:", error);
      });
  };


  // Function to handle checkbox state changes
  const handleCheckboxChange = (event, id, name) => {
    const checked = event.target.checked;
    setCheckedState(prevState => ({
      ...prevState,
      [id]: checked
    }));

    if (checked) {
      const {
        campus = { campId: '', campName: '' },
        orglocation = { locationId: '', locationName: '' },
        orgId = ''
      } = location?.state || {};

      const newState = {
        campus,
        orglocation,
        assembly: {
          assemblyId: id,
          assemblyName: name
        },
        orgId
      };
      navigate('/organization/zones', { state: newState });
    }
  };

  // Function to create a new assembly
  const createAssembly = data => {
    dispatch(addAssembly({ data, navigate, setLoader })).then(() => {
      setModalShow({ show: false, id: '' })
      dispatch(assemblyList({ navigate, setLoader, locationId }))
    })
  }

  // Function to edit an existing assembly
  const editAssembly = data => {
    dispatch(updateAssembly({ id: modalShow.id, data, navigate, setLoader, locationId }))
    setModalShow({ show: false, id: '' })
  }

  // Function to remove a assembly
  const removeAssembly = id => {
    dispatch(deleteAssembly({ id, navigate, setLoader, locationId })).then(() => {
      dispatch(assemblyList({ navigate, setLoader, locationId }))
    })
    setDeleteModal({ show: false })
  }

  // Effect to reset form values and clear errors when the modal is closed
  useEffect(() => {
    if (!modalShow.show) {
      setValue('name', '')
      clearErrors()
    }
  }, [modalShow.show, setValue, clearErrors])

  return (
    <>
      <div className='org'>
        <div className='org_header d-flex align-items-center justify-content-between'>
          <h1 className='org_header_heading'>Assembly Points</h1>
          <button type='button' className='submit_btn' onClick={() => setModalShow({ show: true })}>+ Add ASSEMBLY PTS</button>
        </div>
        <InfiniteScroll
          fetchMoreData={() => fetchMoreAssembly(0)}
          hasMore={hasMore}
          isLoading={assemblyStatus === 'loading'}
          threshold={200}
        >
          <div className='org_table table-responsive table-border-0'>
            <table className="table">
              <thead>
                <tr>
                  <td className='org_table_column w-5 zone_table_heading'> </td>
                  <td className='org_table_column w-40 zone_table_heading'>Assembly Points</td>
                  <td className='org_table_column w-40 text-center zone_table_heading'>Action</td>
                </tr>
              </thead>
              <tbody>
                {assemblyData?.data?.map(item => (
                  <tr key={`${item.id}`}>
                    <td className='org_table_row w-5 zone_body_text'>

                      <label className='check_box ml-2' htmlFor={`checkbox-${item.id}`}>
                        <input
                          type='checkbox'
                          id={`checkbox-${item.id}`}
                          checked={checkedState[item.id] || false}
                          onChange={(e) => handleCheckboxChange(e, item.id, item.name)}
                        />
                        <span className='checkbox_check'></span>
                      </label>
                    </td>
                    <td className='org_table_row w-40 zone_body_text'>{item?.name}</td>
                    <td className='org_table_row w-40 zone_body_text'>
                      <div className='d-flex align-items-center justify-content-center'>
                        <button type='button' className='action_btns mr-4' onClick={() => {
                          setModalShow({ show: true, id: item.id })
                          setValue('name', item.name)
                        }}>
                          <img src={editImg} alt='' className='mr-1' />
                          Edit
                        </button>

                        <button
                          type='button'
                          className='action_btns'
                          // onClick={() => removeAssembly(item.id)}
                          onClick={() => setDeleteModal({ show: true, id: item.id, name: item.name })}
                        >
                          <img src={deleteImg} alt='' className='mr-1' />
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}

              </tbody>
            </table>
          </div>
        </InfiniteScroll>
      </div>
      <CustomModal
        show={modalShow.show}
        onHide={() => setModalShow({ show: false })}
        heading={modalShow.id ? 'Edit Assembly Point' : 'Add Assembly Point'}
        size="md"
        body={
          <form onSubmit={
            modalShow.id
              ? handleSubmit(editAssembly)
              : handleSubmit(createAssembly)
          }
          >
            <div className='row'>
              <div className="col-lg-12">
                <div className="form-group">
                  <label className='innerlable'>Assembly Points Name</label>
                  <input type="text" className="form-control" placeholder="type here"   {...register('name', { required: 'Assembly Points name required' })} />
                  {errors.name && (
                    <p className='text-danger'>{errors.name.message}</p>
                  )}
                </div>
                <CustomBtn
                  buttonText="Save"
                  className="mt-5"
                  type="submit"
                  id="assemblyName" />
              </div>
            </div>
          </form>
        }
      />
      <CustomModal
        show={deleteModal.show}
        onHide={() => setDeleteModal({ show: false })}
        // heading="Delete Campus"
        size="md"
        body={
          <div className='deleteModal'>
            <p className='text-center mb-5'>Are you sure, you want to delete this {deleteModal.name}?</p>
            <div className='d-flex justify-content-between align-items-center custom_bottom_padding'>
              <button type='button' className='submit_btn' onClick={() => removeAssembly(deleteModal.id)}>Yes</button>
              <button type='button' className='cancleBtn' onClick={() => setDeleteModal({ show: false })}>No</button>
            </div>
          </div>
        }
      />
    </>

  )
}

export default AssemblyPoint